import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../Header";
import LiteracyNumeracy from "./LiteracyNumeracy";
import { BackLibrary } from "../common/BackLibrary";
import HealthQuestionnaire from "./HealthQuestionnaire";
import NewStarterChecklist from "./NewStarterChecklist";
import BankDetails from "./BankDetails";
import ComplianceAndOtherDocuments from "./ComplianceAndOtherDocuments";
import WorkExperience from "./WorkExperience";
import Lfuk48hrOptOutForm from "./Lfuk48hrOptOutForm";
import LfukRecruitmentServicesLimitedTermsOfEngagement from "./LfukRecruitmentServicesLimitedTermsOfEngagement";
import LfukKidForPaye from "./LfukKidForPaye";
import GdprJobApplicationProcessingConsentForm from "./GdprJobApplicationProcessingConsentForm";
import GdprPolicy from "./GdprPolicy";

const Documents = ({ currentDocument, user }) => {
  const [currentStep, setCurrentStep] = useState("");
  useEffect(() => {
    setCurrentStep(currentDocument?.key);
  }, [currentDocument]);
  return (
    <>
      <div className="container-fluid container-fluid-login">
        <Header />
        <div className="row" style={{ height: "auto" }}>
          <div className="col-md-8 p-4 bg-white">
            <h2>{currentDocument?.name}</h2>
            <p>
              This form has been assigned to you, please complete it accurately.
            </p>
          </div>
          <div className="col-md-4 p-4 bg-white text-end">
            <BackLibrary user={user}/>
          </div>
        </div>
        {/* Conditionally render components based on the current step */}
        {currentStep === "literacyAndNumeracyAssessment" && (
          <LiteracyNumeracy />
        )}
        {currentStep === "healthQuestionnaire" && <HealthQuestionnaire />}
        {currentStep === "newStarterChecklist" && <NewStarterChecklist />}
        {currentStep === "complianceAndOtherDocuments" && (
          <ComplianceAndOtherDocuments />
        )}
        {currentStep === "bankDetails" && <BankDetails />}
        {currentStep === "workExperience" && <WorkExperience />}
        {currentStep === "lfuk48hrOptOutForm" && <Lfuk48hrOptOutForm />}
        {currentStep === "lfukRecruitmentServicesLimitedTermsOfEngagement" && (
          <LfukRecruitmentServicesLimitedTermsOfEngagement />
        )}
        {currentStep === "lfukKidForPaye" && <LfukKidForPaye />}
        {currentStep === "gdprJobApplicationProcessingConsentForm" && (
          <GdprJobApplicationProcessingConsentForm />
        )}
        {currentStep === "gdprPolicy" && <GdprPolicy />}
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  user: state.user.loggedInUserData,
});
export default connect(mapStateToProps, {})(Documents);
